import { render } from "./SimpleBar.vue?vue&type=template&id=53c7b022"
import script from "./SimpleBar.vue?vue&type=script&lang=js"
export * from "./SimpleBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__